// React
import { useMemo } from 'react'

// Hooks
import { useAppInfiniteQueryMap } from 'hooks/use-app-infinite-query'
import { AppQueryOptions } from 'hooks/use-app-query'

// Services / API calls
import { getNotifications_ } from 'services/notification'

// Types
import { GetNotificationResponse, NotificationPayload } from 'services/types/notification'
import { Notification } from 'types/global'

// Store mappers / utilities
import { mapNotifications } from 'store/notification'

// Constants
import { STALE_TIME } from 'utils/constants'
import { notificationsKey } from 'utils/constants/queryKey'

export const mapSearchLeadResponse = (
  result: GetNotificationResponse,
): { count: string | number; data: Notification[] } => ({
  count: result.total_unread,
  data: mapNotifications(result),
})

export const useGetNotifications = (payload: NotificationPayload, options?: AppQueryOptions) => {
  const queryResult = useAppInfiniteQueryMap(
    notificationsKey.list(),
    ({ pageParam = 0 }) => getNotifications_({ ...payload, last_record_id: pageParam || 0 }),
    mapSearchLeadResponse,
    {
      ...options,
      staleTime: STALE_TIME.lookup,
    },
  )

  const computedList: Notification[] = useMemo(
    () => queryResult.data?.pages?.flatMap((page) => page?.data || []) || [],
    [queryResult.data],
  )

  const totalCount = useMemo(
    () => Math.max(...(queryResult.data?.pages?.map((page) => Number(page?.count) || 0) || [0])),
    [queryResult.data],
  )

  return {
    ...queryResult,
    list: computedList || [],
    totalCount: totalCount || 0,
  }
}
